import type { EsignatureSubmissionEntity } from './entity_types/EsignatureSubmission';
import { hFetch } from './hFetch';

type GetEsignatureSubmissions = {
  contactId: number;
};
export const getEsignatureSubmissions = async ({ contactId }: GetEsignatureSubmissions) => {
  return (await hFetch({ url: `/api/esignature_submissions?id=${contactId}` })) as {
    records: EsignatureSubmissionEntity[];
  };
};
